<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="default_ratio_instantiated"
    :start-opened="default_ratio_instantiated"
    @toggled_visibility="content_visible = $event"
  >
    <div v-if="content_visible">
      <p style="text-align: left;">
        {{ $t('negative_value_predicted') }} : {{ target_values[0] }} |
        {{ negative_value_percentage.toFixed(2) }}%
        <span style="float: right;">
          {{ $t('positive_value_predicted') }} : {{ target_values[1] }} |
          {{ positive_value_percentage.toFixed(2) }}%
        </span>
      </p>
      <b-progress show-progress :max="100">
        <b-progress-bar variant="primary" :value="negative_value_percentage">
        </b-progress-bar>
        <b-progress-bar variant="success" :value="positive_value_percentage">
        </b-progress-bar>
      </b-progress>
      <p>{{ $t('nb_folds_final') }} : {{ nb_folds_final }}</p>
      <p v-if="best_score_available">
        {{ $t('best_score_found') }} : {{ best_score.toFixed(4) }}
      </p>
    </div>
  </unroll-element>
</template>

<i18n>
{
  "en": {
    "negative_value_predicted": "Negative value predicted",
    "positive_value_predicted": "Positive value predicted",
    "nb_folds_final": "Number of folds used",
    "best_score_found": "Score of best model found"
  },
  "fr": {
    "negative_value_predicted": "Valeur négative prédite",
    "positive_value_predicted": "Valeur positive prédite",
    "nb_folds_final": "Nombre de folds utilisés",
    "best_score_found": "Score du meilleur modèle trouvé"
  }
}
</i18n>

<script>
import _ from 'lodash'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import UnrollElement from './unroll_element.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorDefaultRatio',
  components: { UnrollElement },

  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid'],

  data() {
    return {
      content_visible: false,
    }
  },

  computed: {
    _() {
      return _
    },

    default_ratio() {
      let res = (this.metavariables_tracking_info || {}).default_ratio
      return res
    },

    default_ratio_instantiated() {
      let res =
        !_.isUndefined(this.default_ratio) && !_.isNull(this.default_ratio)
      return res
    },

    target_values() {
      let res = (this.metavariables_tracking_info || {}).predicted_values || {}
      return res
    },

    negative_value_percentage() {
      let res = 100 * (1 - this.default_ratio)
      return res
    },
    positive_value_percentage() {
      let res = 100 * this.default_ratio
      return res
    },

    nb_folds_final() {
      let res =
        (this.metavariables_tracking_info || {}).automatic_nb_folds || {}
      return res
    },

    best_score() {
      let res = -(this.metavariables_tracking_info || {}).best_score
      return res
    },

    best_score_available() {
      let res =
        !_.isUndefined(this.best_score) &&
        !_.isNull(this.best_score) &&
        this.best_score !== 0.0

      return res
    },
  },

  watch: {
    default_ratio_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
